import { navigate, useIntl } from "gatsby-plugin-intl";
import React, { useEffect, useRef, useState } from "react";
import { generate } from "shortid";
import axios from "axios";
import { produce } from "immer";
import {
    Button,
    FormControl, FormControlLabel,
    FormLabel,
    Grid,
    Hidden,
    InputLabel,
    makeStyles, Radio, RadioGroup,
    Select,
    TextField
} from "@material-ui/core";
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import Disponibilidad from "./disponibilidad";
import Typography from "@material-ui/core/Typography";
import Pasajeros from "./pasajeros";
import SendIcon from "@material-ui/icons/Send";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReCAPTCHA from "react-google-recaptcha";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";

const useStyles = makeStyles((theme) => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    formControl: {
        display: "flex"
    },
    displayLinebreak: {
        whiteSpace: "pre-line"
    },
    section: {
        marginTop: "1rem"
    },
    calendar: {
        border: "none"
    }
}));

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
const recaptchaRef = React.createRef();

/*
Props:
 sector ={sectorACG} : Sector de ACG "Santa Rosa"
 horas = {horasSR} : array con horas de reservación
 inputFields =  {inputsPailas} : array de los fields
 costos = {costosPailas} : array con tarifas de cobro
 pago = "Pago con tarjeta al ingresar al Parque" | "Trasnferencia"
 diasPevios = {0} : Días de antelación necesarios para una reservación
 diaCerrado = {[1]} : Días de la semana que está cerrado 0 Domingo - 6 Sábado | -1 ninguno
 cerrado = ['2022-07-01']: Array con fechas en las que un sector puede estar cerrado
 */

const Formulario = (props) => {
    Formulario.defaultProps = {
        tipo: "turistas",
        cerrado: [],
        iva: 1
    }
    const intl = useIntl();
    const classes = useStyles();
    const reservationId = generate();
    const estado = props.tipo === "escuela" ? "pendiente" : "activa"
    const [charla, setCharla] = useState("No")


    //Parámetros del sector
    const sectorACG = props.sector;
    const [inputFields, setInputFields] = useState(props.inputFields);
    const newPassenger = props.costos.map((unTipo) => {
        const nacional = (unTipo.currency === "colones") ? "Costa Rica" : "";
        const provincia = (unTipo.currency === "colones") ? "" : "Extranjero";
        return {
            cantidad: 0,
            nombrePax: unTipo.label,
            nacional,
            provincia,
            costo: unTipo.value,
            tarifa: unTipo.name,
            moneda: unTipo.labelCurrency,
            id: unTipo.name,
            subtotal: 0
        }
    })

    let [errorMsg, setErrorMsg] = useState(null)
    let [data, setData] = useState(null);
    const [desglosePagos, setDesglosePagos] = useState([]);
    const [cuposDisponibles, setCuposDisponibles] = useState(0);
    const [pasajeros, setPasajeros] = useState(newPassenger);
    const [paxCount, setPaxCount] = useState(0);
    const [disabledSubmit, setDisableSumbit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comprobante, setComprobante] = useState([]);
    const [diaDeCobro, setDiaDeCobro] = useState(1) // para manejar dias gratis

    const formatDate = (theDate) => {
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' });
        const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(theDate);
        return (`${year}-${month}-${day}`)
    }

    // let minDateDate = new Date();
    // minDateDate.setDate(minDateDate.getDate() + props.diasPevios);
    // while ((props.diaCerrado.includes(minDateDate.getDay()) && !props.feriados.includes(formatDate(minDateDate))) || props.cerrado.includes(formatDate(minDateDate))) {
    //     minDateDate.setDate(minDateDate.getDate() + 1);
    // }

    let minDateDate = new Date();
    minDateDate.setDate(minDateDate.getDate() + props.diasPevios);

    // Permitir 31 de diciembre como una excepción
    const excepcionDinamica = "2025-04-15";

    while (
        ((props.diaCerrado.includes(minDateDate.getDay()) &&
            !props.feriados.includes(formatDate(minDateDate))) ||
            props.cerrado.includes(formatDate(minDateDate))) &&
        formatDate(minDateDate) !== excepcionDinamica // Excepción para 31 de diciembre
    ) {
        minDateDate.setDate(minDateDate.getDate() + 1);
    }


    const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' });
    const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(minDateDate);
    const fechaFormated = (`${year}-${month}-${day}`)

    const [fechaR, setFechaR] = useState(fechaFormated);
    const [fecha, setFecha] = useState(minDateDate);
    const myRef = useRef(null)
    const executeScroll = () => scrollToRef(myRef)

    //Post del formulario al servidor
    useEffect(() => {
        async function sendReservation() {
            if (data !== null) {
                setLoading(true)
                const allData = new FormData();
                if (comprobante !== null) {
                    comprobante.forEach(file => {
                        allData.append(generate(), file);
                    });
                }
                allData.append('data', JSON.stringify(data))
                axios.post("https://reservaciones.acguanacaste.ac.cr/doReserve.php", allData)
                    // axios.post("http://localhost:9000/doReserve.php", data)
                    .then((response) => {
                        // console.log(response);
                        if (response.data === 'Success') {
                            navigate("/gracias/", {
                                state: {
                                    data
                                }
                            })
                            setLoading(false)
                        } else {
                            setErrorMsg(null);
                            let error = []
                            error.push(intl.formatMessage({ id: "error.doReserve" }) + response.data);
                            setLoading(false);
                            setErrorMsg(error);
                            executeScroll()
                        }
                    })
            }
        }
        sendReservation();
    }, [data]); //todo como cambiar a useMemo ?

    //Calculo de costos
    useEffect(() => {
        let isSubscribed = true;

        async function recalcularCosto() {
            if (isSubscribed) {
                let subTDolares = pasajeros.reduce((acc, pax) =>
                    pax.moneda === '$' ? acc + (pax.costo * pax.cantidad * diaDeCobro) : acc, 0);

                const subTNacionalesLocal = pasajeros.reduce((acc, pax) =>
                    pax.moneda === "₡" ? acc + (pax.costo * pax.cantidad * diaDeCobro) : acc, 0);

                if (props.tipo === "escuela" && charla !== "No") {
                    subTDolares += 27;
                }

                const countPasajeros = pasajeros.reduce((acc, pax) =>
                    isNaN(pax.cantidad) ? acc : acc + parseInt(pax.cantidad), 0);
                setPaxCount(countPasajeros);

                const ivaDolares = subTDolares * 0.13 * props.iva;
                const totalDolares = subTDolares + ivaDolares;
                const totalDolaresColonesLocal = totalDolares > 0 ? (totalDolares * tipoDeCambio) : 0;

                const iva = subTNacionalesLocal * 0.13 * props.iva;
                const SubtotalNacionalDisplay = subTNacionalesLocal;
                const totalNacionales = subTNacionalesLocal + iva;
                const totalColones = totalNacionales + totalDolaresColonesLocal;

                const tdc = (typeof tipoDeCambio === 'number') ? "(TC:" + tipoDeCambio.toString() + ")" : "";
                const formatColones = { maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'CRC' };
                const formatDolares = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

                const desglosePagos = props.sector === "Horizontes"
                    ? desglosePagosHorizontes({ intl, SubtotalNacionalDisplay, totalNacionales, totalColones, formatColones })
                    : desglosePagosGeneral({ intl, subTDolares, ivaDolares, totalDolares, totalDolaresColonesLocal, tdc, SubtotalNacionalDisplay, iva, totalNacionales, totalColones, formatColones, formatDolares });

                await setDesglosePagos(desglosePagos);
            }
        }

        recalcularCosto();
        return () => (isSubscribed = false);
    }, [pasajeros, charla, diaDeCobro]);


    const desglosePagosHorizontes = ({ intl, SubtotalNacionalDisplay, totalNacionales, totalColones, formatColones }) => [
        { label: "", value: "____________" },
        { label: intl.formatMessage({ id: "subtNac" }), value: SubtotalNacionalDisplay.toLocaleString('es-CR', formatColones) },
        { label: intl.formatMessage({ id: "totalNac" }), value: totalNacionales.toLocaleString('es-CR', formatColones) },
        { label: "", value: "____________" },
        { label: intl.formatMessage({ id: "total" }), value: totalColones.toLocaleString('es-CR', formatColones) },
    ];
    
    const desglosePagosGeneral = ({ intl, subTDolares, ivaDolares, totalDolares, totalDolaresColonesLocal, tdc, SubtotalNacionalDisplay, iva, totalNacionales, totalColones, formatColones, formatDolares }) => [
        { label: intl.formatMessage({ id: "subtExtDol" }), value: "$" + subTDolares.toLocaleString('es-CR', formatDolares) },
        { label: intl.formatMessage({ id: "iva" }), value: "$" + ivaDolares.toLocaleString('es-CR', formatDolares) },
        { label: intl.formatMessage({ id: "totalExt" }), value: "$" + totalDolares.toLocaleString('es-CR', formatDolares) },
        { label: intl.formatMessage({ id: "subtExtCol" }) + tdc, value: totalDolaresColonesLocal.toLocaleString('es-CR', formatColones) },
        { label: "", value: "____________" },
        { label: intl.formatMessage({ id: "subtNac" }), value: SubtotalNacionalDisplay.toLocaleString('es-CR', formatColones) },
        { label: intl.formatMessage({ id: "iva" }), value: iva.toLocaleString('es-CR', formatColones) },
        { label: intl.formatMessage({ id: "totalNac" }), value: totalNacionales.toLocaleString('es-CR', formatColones) },
        { label: "", value: "____________" },
        { label: intl.formatMessage({ id: "total" }), value: totalColones.toLocaleString('es-CR', formatColones) },
    ];
    


    async function TipoDeCambio() {
        try {
            return await axios.get('https://reservaciones.acguanacaste.ac.cr/getTC.php')
                .then(function (response) {
                    const info = response.data
                    // console.log("tcxx:",info,response)
                    setTipoDeCambio(info)
                    return info;
                })
        } catch (error) {
            throw new Error(error);
        }
    };
    const getTipoDeCambio = TipoDeCambio;
    var [tipoDeCambio, setTipoDeCambio] = useState(getTipoDeCambio);


    /*
    Desactiva los botones de agregar pasajero y enviar en caso de no haber cupos.
     */
    const handleCuposChanges = (cupo) => {
        setCuposDisponibles(cupo)
        if (cupo === 0) {
            setErrorMsg(null)
        } else if (cupo < 0) {
            setDisableSumbit(true)
            setErrorMsg([intl.formatMessage({ id: "error.masPersonas" })])
        }
        else {
            setDisableSumbit(false)
            setErrorMsg(null)
        }
    }



    //Validación
    const validateForm = () => {
        let valid = true;
        let errores = [];
        inputFields.forEach(function (field, index) {
            if (field.required && (typeof field.value == "undefined" || field.value.length < 1)) {
                errores.push(intl.formatMessage({ id: field.label }));
                valid = false
            }
        })

        let nan, procedencia, hayExonerados = false;
        pasajeros.forEach(function (pax, index) {
            if (isNaN(pax.cantidad) && !nan) {
                errores.push(intl.formatMessage({ id: "error.nanQty" }));
                valid = false;
                nan = true;
            }
            if (pax.cantidad > 0 && ((pax.nacional === "Costa Rica" && pax.provincia === "") || pax.nacional === "") && !procedencia) {
                errores.push(intl.formatMessage({ id: "error.pais" }))
                valid = false;
                procedencia = true;
            }

            if (pax.id === "exnoeradoPorResolucion" && pax.cantidad > 0) {
                hayExonerados = true;
            }
        })
        if (paxCount < 1) {
            valid = false;
            errores.push(intl.formatMessage({ id: "error.ceroPax" }));
        }
        if (desglosePagos === null) {
            valid = false;
            errores.push(intl.formatMessage({ id: "error.catPago" }));
        }
        if (inputFields[0].value < new Date()) {
            valid = false;
            errores.push(intl.formatMessage({ id: "error.fechaMayor" }))
        }
        if (props.pago === "Transferencia") {
            if (comprobante.length < 1) {
                valid = false;
                errores.push(intl.formatMessage({ id: "error.compDeposito" }))
            }
        }
        if (props.tipo === "escuela") {
            const exonerado = inputFields.filter(field => field.type === "exoneracion")[0]
            if ((exonerado.value === "Si" || hayExonerados) && comprobante.length < 1) {
                valid = false;
                errores.push(intl.formatMessage({ id: "error.compExoneracion" }))
            }
        }
        if (errores.length > 0) {
            errores.unshift(intl.formatMessage({ id: "error.requeridos" }))
            executeScroll()
        }

        setErrorMsg(errores)
        return valid;
    };

    //Alistar los datos para enviarlos.
    const handleSubmit = () => {
        setErrorMsg(null);
        setData(null);
        const validForm = validateForm();
        if (validForm) {
            setData([{
                sector: encodeURI(sectorACG),
                reservacion: reservationId,
                detalles: inputFields,
                pasajeros: pasajeros,
                fecha: fechaR,
                status: estado,
                pago: props.pago,
                desglosePagos,
                tipo: props.tipo,
                action: "insert",

            }]);
        }
    }


    const setTheDate = (theDate) => {
        setFecha(theDate)
        const fechaFormated = formatDate(theDate);
        setFechaR(fechaFormated)
        setInputFields(currentInputFields =>
            produce(currentInputFields, v => {
                v[0].value = fechaFormated;
            }))
        const [{ value: month }, , { value: day }] = dateTimeFormat.formatToParts(theDate);
        const diaGratis = (month == 8 && day == 24) ? 0 : 1; //24 de agosto día de parques es gratis la entrada
        setDiaDeCobro(diaGratis)
    }

    return (

        <>
            <Grid container spacing={3} ref={myRef}>
                <Grid item xs={12}>
                    <FormErrors errors={errorMsg} />
                </Grid>
                {(diaDeCobro === 1) ? null : (
                    <Grid item container alignItems="center"
                        style={{ backgroundColor: "rgb(235,253,234)", padding: "1rem" }} xs={12}>
                        <Grid item xs={1}>
                            <ReportProblemIcon style={{ color: "#356732" }} />
                        </Grid>
                        <Grid item xs={11} md={11}>
                            <Typography variant={"body2"} style={{ color: "#356732" }}>
                                {intl.formatMessage({ id: "diaParques" })}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={6} sm={4} md={4}>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="fecha" className={" MuiInputLabel-shrink MuiFormLabel-filled"}>{intl.formatMessage({ id: "fechaViaje" })}</InputLabel>
                        <DatePicker
                            id={"fecha"}
                            value={fecha}
                            locale={"es-CR"}
                            tileDisabled={({ date }) => {
                                const dateFormated = formatDate(date);
                                const excepciones = ["2024-07-09", "2024-12-31", "2025-04-15"];

                                if (excepciones.includes(dateFormated)) {
                                    return false;
                                }

                                return (
                                    props.diaCerrado.includes(date.getDay()) &&
                                    !props.feriados.includes(dateFormated)
                                ) || props.cerrado.includes(dateFormated);
                            }}
                            className={
                                classes.calendar +
                                " MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                            }
                            onChange={(value) => {
                                setTheDate(value);
                            }}
                            minDate={minDateDate}
                        />

                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="hora">{intl.formatMessage({ id: "horaLl" })}</InputLabel>
                        <Select
                            label={intl.formatMessage({ id: "horaLl" })}
                            native
                            className={classes.textField}
                            value={inputFields[1].value}
                            onChange={(e) => {
                                const hora = e.target.value;
                                setInputFields(currentInputFields =>
                                    produce(currentInputFields, v => {
                                        v[1].value = hora;
                                    }))
                            }}
                            inputProps={{
                                name: 'hora',
                                id: 'hora',

                            }}
                        >
                            {props.horas.map((unaHora, index) => {
                                return (<option key={index} value={unaHora.value}>{unaHora.label}</option>)
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item sm={3} md={2}>
                    <Disponibilidad sector={sectorACG}
                        fecha={fechaR}
                        paxCount={paxCount}
                        cuposDisponibles={cuposDisponibles}
                        onChange={handleCuposChanges}
                    />
                </Grid>

            </Grid>
            <Detalles
                inputFields={inputFields}
                setInputFields={setInputFields}
                position={"mid"}
                charla={charla}
                setCharla={setCharla}
                setComprobante={setComprobante}
                width={4}

            />

            <Grid container className={classes.section} spacing={3} alignItems="center">
                <Grid item xs={12}>
                    <FormLabel component="legend">{intl.formatMessage({ id: "pasajeros" })}</FormLabel>
                    <Typography variant={"body2"}>{intl.formatMessage({ id: "gruposPax" })}</Typography>

                </Grid>
            </Grid>
            <Pasajeros
                pasajeros={pasajeros}
                setPasajeros={setPasajeros}
                diaDeCobro={diaDeCobro}
            />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {(props.pago === "Transferencia") ? (
                        <FormLabel component="legend">{intl.formatMessage({ id: "pres" })}</FormLabel>
                    ) : (
                        <Typography variant={"body1"}>{intl.formatMessage({ id: "prespailas" })}</Typography>
                    )}
                </Grid>
                <NumerosDeCuenta
                    pago={props.pago}
                    sector={props.sector}
                />

                <Grid item xs={12} md={6}>
                    {desglosePagos.map((pago, index) => {
                        return (
                            <Grid key={index} item xs={12} container justifyContent={"flex-end"}>
                                <Grid item xs={9}>
                                    <Typography variant={"body1"}>{pago.label}</Typography>
                                </Grid>
                                <Grid item xs={3} style={{ textAlign: "right" }}>
                                    <Typography variant={"body1"}>
                                        <strong> {pago.value}</strong>
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>

            </Grid>

            {(props.pago === "Transferencia") && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant={"body2"}>
                            {intl.formatMessage({ id: "numDep" })}
                        </Typography>
                    </Grid>


                    <Grid item xs={6} md={6}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor={"comprobante"} id="comprobante-label">{intl.formatMessage({ id: "comprob" })}</InputLabel>
                            <input accept="image/*, application/pdf"
                                id="comprobante"
                                type="file"
                                multiple={true}
                                onChange={(e) => {
                                    let files = [];
                                    for (let i = 0; i < e.target.files.length; i++) {
                                        files.push(e.target.files[i]);
                                    }
                                    setComprobante(files)
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <Detalles
                            inputFields={inputFields}
                            setInputFields={setInputFields}
                            position={"bottom"}
                            width={6}
                            setCharla={setCharla}
                            setComprobante={setComprobante}
                        />
                    </Grid>
                </Grid>
            )}

            <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        type={"Submit"}
                        disabled={disabledSubmit}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit()
                        }}
                        startIcon={<SendIcon />}
                    >{intl.formatMessage({ id: "enviar" })}
                    </Button>
                    {loading ? <div><CircularProgress /> {intl.formatMessage({ id: "espere" })}</div> : null}
                </Grid>


            </Grid>
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey="6LdtF6YZAAAAADQ-dNM1T1N7OY7UnQ8VioDwGVP0"
            />

        </>
    )
}

const Detalles = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    Detalles.defaultProps = {
        width: 4,
        charla: "No"
    }
    const [exnorado, setExonerado] = useState("No")
    return (
        <Grid container spacing={3}>
            {props.inputFields.map((item, index) => {
                if (item.position === props.position) {
                    if (item.type === "exoneracion") {
                        return (
                            <Grid item container xs={12} key={index}>
                                <Grid item xs={6} md={props.width} >
                                    <FormLabel component="legend">{intl.formatMessage({ id: "exres" })}</FormLabel>
                                    <RadioGroup row
                                        label={intl.formatMessage({ id: "exres" })}
                                        name={"exonerado"}
                                        value={item.value}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            props.setInputFields(currentInputFields =>
                                                produce(currentInputFields, v => {
                                                    v[index].value = value;
                                                }))
                                            setExonerado(value)
                                        }}
                                    >
                                        <FormControlLabel
                                            value="Si"
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "Si" })}
                                            labelPlacement="start"
                                        />
                                        <FormControlLabel
                                            value="No"
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "No" })}
                                            labelPlacement="start"
                                        />
                                    </RadioGroup>
                                </Grid>
                                <Grid item sm={3}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel htmlFor={"comprobante"} id="comprobante-label">{intl.formatMessage({ id: "comprob" })}</InputLabel>
                                        <input accept="image/*, application/pdf"
                                            disabled={(exnorado !== "Si")}
                                            id="comprobante"
                                            type="file"
                                            multiple={true}
                                            onChange={(e) => {
                                                let files = [];
                                                for (let i = 0; i < e.target.files.length; i++) {
                                                    files.push(e.target.files[i]);
                                                }
                                                console.log("files", files);
                                                props.setComprobante(files)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )
                    }
                    if (item.type === "charla") {
                        return (
                            <Grid item container xs={12} key={index}>
                                <Grid item xs={6} md={props.width} >

                                    <FormLabel component="legend">{item.label}</FormLabel>
                                    <RadioGroup row
                                        aria-label={item.label}
                                        name={item.name}
                                        value={props.charla}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            props.setInputFields(currentInputFields =>
                                                produce(currentInputFields, v => {
                                                    v[index].value = value;
                                                }))
                                            props.setCharla(value)
                                        }}
                                    >
                                        <FormControlLabel
                                            value={"Si"}
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "Si" })}
                                            labelPlacement="start"
                                        />
                                        <FormControlLabel
                                            value="No"
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "No" })}
                                            labelPlacement="start"
                                        />
                                    </RadioGroup>

                                </Grid>
                                <Grid item xs={3} md={props.width} key={index}>
                                    <FormLabel component="legend">{intl.formatMessage({ id: "horaCharla" })}</FormLabel>
                                    <RadioGroup row
                                        disabled={(props.charla === "No")}
                                        required={(props.charla === "No")}
                                        label={intl.formatMessage({ id: "horaCharla" })}
                                        name={item.name}
                                        value={item.hora}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            props.setInputFields(currentInputFields =>
                                                produce(currentInputFields, v => {
                                                    v[index].value = "Si";
                                                    v[index].hora = value
                                                    console.log(v[index].value)
                                                }))
                                        }}
                                    >

                                        <FormControlLabel
                                            value="9:00 am"
                                            disabled={(props.charla === "No")}
                                            control={<Radio />}
                                            label="9:00 am"
                                            labelPlacement="start"
                                        />
                                        <FormControlLabel
                                            value="1:00 pm"
                                            disabled={(props.charla === "No")}
                                            control={<Radio />}
                                            label="1:00pm"
                                            labelPlacement="start"
                                        />
                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={6} md={12}>
                                    <Typography variant={"body2"}>
                                        Las charlas tienen un costo de $27 y son sujetas a disponibilidad de personal el
                                        día de su visita. En los próximos tres días hábiles se le confirmará la
                                        disponibilidad de charla para su fecha.
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    }
                    if (item.type === "email" || item.type === "text") {
                        return (
                            <Grid item xs={6} md={props.width} key={index}>
                                <TextField type={item.type} name={item.name}
                                    label={intl.formatMessage({ id: item.label })} fullWidth
                                    required={item.required}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        props.setInputFields(currentInputFields =>
                                            produce(currentInputFields, v => {
                                                v[index].value = value;
                                            }))
                                    }}
                                />
                            </Grid>
                        )
                    }
                }
                return (<div key={index}></div>)
            })
            }
        </Grid>
    )

}
const FormErrors = (props) => {
    const errores = props.errors;
    return (
        <>
            {(errores !== null && errores.length > 0) && (
                <Grid container alignItems="center" style={{ backgroundColor: "rgb(253, 236, 234)", padding: "1rem" }}>
                    <Grid item xs={1}>
                        <ReportProblemIcon style={{ color: "#ad1d1d" }} />
                    </Grid>
                    <Grid item xs={11} md={11}>
                        <Typography variant={"body2"} style={{ color: "#ad1d1d" }}>
                            {errores.map((error, index) => {
                                return (
                                    (index > 1 ? ', ' : '') + error
                                )
                            })
                            }
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </>
    );
}

const NumerosDeCuenta = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    if (props.pago === "Transferencia") {
        if (props.sector === "Horizontes") {
            return (
                <>
                    <Grid item xs={12} md={5}>
                        <Typography className={classes.displayLinebreak} variant={"body2"}>
                            {intl.formatMessage({ id: "descDep" })} "Visita al Sector {props.sector}, ACG"
                            <br /><br />
                            {intl.formatMessage({ id: "ctaColFun1" })} <br />
                            {intl.formatMessage({ id: "ctaColFun2" })} <br />
                            {intl.formatMessage({ id: "ctaColFun3" })} <br />
                            {intl.formatMessage({ id: "ctaColFun4" })} <br />
                            {intl.formatMessage({ id: "ctaColFun5" })} Fundación de Parques Nacionales<br />
                            {intl.formatMessage({ id: "ctaColFun6" })} <br /><br />
                            {/* {intl.formatMessage({ id: "ctaDolFun1" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun2" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun3" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun4" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun5" })} Fundación de Parques Nacionales<br />
                            {intl.formatMessage({ id: "ctaDolFun6" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun7" })} <br /> */}
                        </Typography>
                    </Grid>
                    <Grid item md={1} display={{ xs: 'none' }}>
                    </Grid>
                </>
            )
        } else {
            return (
                <>
                    <Grid item xs={12} md={5}>
                        <Typography className={classes.displayLinebreak} variant={"body2"}>
                            {intl.formatMessage({ id: "descDep" })} "Visita al Sector {props.sector}, ACG"
                            <br /><br />
                            {intl.formatMessage({ id: "ctaColSINAC1" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC2" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC3" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC4" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC5" })}SINAC FONDO DE PARQUES NACIONALES <br />
                            {intl.formatMessage({ id: "ctaColSINAC6" })} <br />
                            <br />
                            {intl.formatMessage({ id: "ctaDolSINAC1" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC2" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC3" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC4" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC5" })}SINAC FONDO DE PARQUES NACIONALES <br />
                            {intl.formatMessage({ id: "ctaDolSINAC6" })} <br />
                        </Typography>
                    </Grid>
                    <Grid item md={1} display={{ xs: 'none' }}>
                    </Grid>
                </>
            )
        }
    }
    else {
        return (
            <Hidden mdDown>
                <Grid item md={6}>
                    <br />
                </Grid>
            </Hidden>


        )
    }
}

export default Formulario

